/*
 * Registration Messages
 *
 * This contains all the text for the Registration component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  startLabel: {
    id: 'app.components.Planner.Registration.startLabel',
    defaultMessage: 'Start',
  },
  startHelp: {
    id: 'app.components.Planner.Registration.startHelp',
    defaultMessage: 'Registration for the meetings start on:',
  },
  startImmediate: {
    id: 'app.components.Planner.Registration.startImmediate',
    defaultMessage: 'Registration starts immediately after saving the planning',
  },
  endLabel: {
    id: 'app.components.Planner.Registration.endLabel',
    defaultMessage: 'End',
  },
  endHelp: {
    id: 'app.components.Planner.Registration.endHelp',
    defaultMessage: 'Registration closes on:',
  },
  endMoreHelp: {
    id: 'app.components.Planner.Registration.endMoreHelp',
    defaultMessage: 'If you leave the end date open, registration closes after the last meeting',
  },
  announceText: {
    id: 'app.components.Planner.Registration.announceText',
    defaultMessage: 'Send announcements about parent meetings:',
  },
  announceDirect: {
    id: 'app.components.Planner.Registration.announceDirect',
    defaultMessage: 'Immediately',
  },
  announceOneDay: {
    id: 'app.components.Planner.Registration.announceOneDay',
    defaultMessage: '1 day before registration opens',
  },
  announceOneWeek: {
    id: 'app.components.Planner.Registration.announceOneWeek',
    defaultMessage: '1 week before registration opens',
  },
});
